import { render, staticRenderFns } from "./patientInfo.html?vue&type=template&id=135c2049&scoped=true&external"
import script from "./patientInfo.js?vue&type=script&lang=js&external"
export * from "./patientInfo.js?vue&type=script&lang=js&external"
import style0 from "./patientInfo.scss?vue&type=style&index=0&id=135c2049&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135c2049",
  null
  
)

export default component.exports